import Reviews from 'app/pages/web/Account/Activity/Reviews';
import HostContentWrapper from 'app/utils/wrapper/host/content';

const HostReviews = () => (
    <HostContentWrapper>
        <Reviews />
    </HostContentWrapper>
)
export default HostReviews;